import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'quantity'
})
export class QuantityPipe implements PipeTransform {
    transform(value: number) {
        if (value === null) return null;
        return Math.round(value * 1000) / 1000;
    }
}

@Pipe({
    name: 'quantityFraction'
})
export class QuantityFractionPipe implements PipeTransform {
    transform(value: number) {
        if (value === null || isNaN(value)) return null;
        if (value === 0) return 0;

        value = Math.round(value * 8) / 8;
        let wholeVal = value > 0 ? Math.floor(value) : Math.ceil(value);
        let wholeStr = (value < 0 ? '-' : '') + ((wholeVal == 0) ? '' : wholeVal.toString() + ' ');
        let frac = Math.abs(value % 1);

        if (frac == 0) {
            return wholeStr;
        } else if (frac == 1 / 8) {
            return wholeStr + '⅛';
        } else if (frac == 2 / 8) {
            return wholeStr + '¼';
        } else if (frac == 3 / 8) {
            return wholeStr + '⅜';
        } else if (frac == 4 / 8) {
            return wholeStr + '½';
        } else if (frac == 5 / 8) {
            return wholeStr + '⅝';
        } else if (frac == 6 / 8) {
            return wholeStr + '¾';
        } else if (frac == 7 / 8) {
            return wholeStr + '⅞';
        } else {
            return value;
        }
    }
}